export default __webpack_public_path__ + "static/media/carfillo-festival.68df73e4.png";